import React from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from 'components/ui/dialog';
import { Button } from 'components/ui/button';

const AgencyModal = ({ isOpen, onClose, title, description, formId, submitLabel, savingLabel, isSaving, children }) => (
  <Dialog open={isOpen} onOpenChange={onClose}>
    <DialogContent
      overlayClassName="!bg-[#14231b75]"
      className="!flex !w-[calc(100%_-_20px)] !max-w-[640px] !max-h-[calc(100dvh_-_40px)] !flex-col !gap-0 !overflow-hidden !rounded-xl !border-[#e2e7e3] !bg-white !p-0 shadow-[0_18px_60px_#14231b24]"
    >
      <DialogHeader className="shrink-0 border-b border-[#e8ede9] px-6 py-4 pr-14 !text-left">
        <DialogTitle className="line-clamp-2 break-words text-[18px] font-semibold leading-[25px] text-[#273b2f]">
          {title}
        </DialogTitle>
        <DialogDescription className="!mt-1 text-[13px] leading-5 text-[#748178]">{description}</DialogDescription>
      </DialogHeader>
      <div className="min-h-0 overflow-y-auto overscroll-contain px-6 py-4">{children}</div>
      <DialogFooter className="!flex !w-full shrink-0 !flex-row flex-wrap justify-end gap-2 border-t border-[#e3eae5] px-6 py-3">
        <Button
          type="button"
          variant="outline"
          onClick={onClose}
          className="h-10 border-[#d6dfd9] bg-white px-3 text-[#42594a] shadow-none"
        >
          Annuler
        </Button>
        <Button
          type="submit"
          form={formId}
          disabled={isSaving}
          className="h-10 bg-[#28764d] px-3 text-white shadow-none hover:bg-[#246e48]"
        >
          {isSaving ? savingLabel : submitLabel}
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);

AgencyModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  formId: PropTypes.string.isRequired,
  submitLabel: PropTypes.string.isRequired,
  savingLabel: PropTypes.string.isRequired,
  isSaving: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
};

export default AgencyModal;
